/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Container,
  Dimmer,
  Divider,
  Grid,
  Loader,
  Button,
} from 'semantic-ui-react';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { getItem } from '../../utils/storage';
import AppForm from '../../components/AppForm';
import NavBar from '../../components/NavBar';
import { fetchGlobalSettings } from '../../actions/globalSettings';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import config from '../../../config';

class PriceNaming extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);

    let globalSettings = {};
    const storeGloablSettings = getItem(`${config.get('appName')}.globalSettings`);
    if (storeGloablSettings) {
      try {
        globalSettings = JSON.parse(storeGloablSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    this.state = {
      loading: false,
      token: null,
      data: globalSettings,
      oriData: [],
    };
    this.validation = {
      sellingPrice: createRef(),
      unitSellingPrice: createRef(),
      nettSellingPrice: createRef(),
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillUnmount() {
    const { store } = this.context;
    store.dispatch(fetchGlobalSettings(true));
    window.removeEventListener('resize', this.handleResize, false);
  }

  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }

  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }

  checkSaveDisabled = () => {
    const { data, oriData } = this.state;
    if (JSON.stringify(data) !== JSON.stringify(oriData)) {
      return false;
    }
    return true;
  }

  handleSave = (e) => {
    if (e) e.preventDefault();
    const { data } = this.state;
    AppForm.validate(this.validation, data)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        this.updateSystemSettings(validations, data);
      });
  }

  handleResize = () => {
    const state = {};
    const topMenuIsTab = window.innerWidth <= 590;
    if (topMenuIsTab !== this.state.topMenuIsTab) {
      state.topMenuIsTab = topMenuIsTab;
    }
    const menuIsTab = window.innerWidth >= 991;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const menuIsVertical = window.innerWidth >= 991;
    if (menuIsVertical !== this.state.menuIsVertical) {
      state.menuIsVertical = menuIsVertical;
    }
    this.setState({ ...state });
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(s => ({
      data: {
        ...s.data,
        [name]: value,
      },
    }));
  }

  async updateSystemSettings(validations, data) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    const stateData = data;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      this.setLoading(false);
      return;
    }
    try {
      await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(stateData),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(fetchGlobalSettings(true));
    store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('System settings successfully updated.', { ns: TRANSLATION_FILES.translation }) }));
  }

  render() {
    const { loading, data } = this.state;
    const { t } = this.props;
    const fields = [
      {
        name: 'unitSellingPrice',
        value: data.unitSellingPrice,
        label: 'List Price',
      },
      {
        name: 'sellingPrice',
        value: data.sellingPrice,
        label: 'SPA Value',
      },
      {
        name: 'nettSellingPrice',
        value: data.nettSellingPrice,
        label: 'Nett Selling Price',
      },
    ];
    return (
      <Container className="priceNaming">
        <NavBar
          header={t('Price', { ns: TRANSLATION_FILES.screens })}
          rightNav={
            <Button
              color="green"
              content={t('Save', { ns: TRANSLATION_FILES.translation })}
              disabled={this.state.loading || this.checkSaveDisabled()}
              onClick={this.handleSave}
            />}
        />
        <Grid verticalAlign="middle" columns="equal" stackable>
          <Grid.Row>
            <Grid.Column>
              <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Divider horizontal>{t('Price Naming', { ns: TRANSLATION_FILES.screens })}</Divider>
              {
                fields.map(f => (
                  <section className="inputBox" key={f.name}>
                    <AppForm.Input
                      label={`${t(f.label, { ns: TRANSLATION_FILES.translation })}:`}
                      name={f.name}
                      value={f.value}
                      onChange={this.handleInputChange}
                      ref={this.validation[f.name]}
                    />
                  </section>
                ))
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(PriceNaming);



// WEBPACK FOOTER //
// ./src/containers/PriceNaming/PriceNaming.jsx